import type { History } from 'history';
import type { IRouteConfigSettings } from '../../interface/config';
import type { IRouteTourSelect } from './interface';
import type { IQueryURL } from '../../interface/util';
import { IRouteActionResult } from '../../interface/route';
import util from './util';

function push(
    settings: IRouteConfigSettings,
    query: IQueryURL,
    history: History,
    props: IRouteTourSelect,
): Promise<IRouteActionResult> {
    return new Promise(async function (resolve, reject) {
        try {
            const isRoutable = await util.isRoutable(props);

            if (isRoutable.didLaunchAction) {
                history.push(settings.pathPrefix + query.assemble(props));
            }

            resolve(isRoutable);
        } catch (error) {
            reject(error);
        }
    });
}

function replace(
    settings: IRouteConfigSettings,
    query: IQueryURL,
    history: History,
    props: IRouteTourSelect,
): Promise<IRouteActionResult> {
    return new Promise(async function (resolve, reject) {
        try {
            const isRoutable = await util.isRoutable(props);

            if (isRoutable.didLaunchAction) {
                history.replace(settings.pathPrefix + query.assemble(props));
            }

            resolve(isRoutable);
        } catch (error) {
            reject(error);
        }
    });
}

const module = {
    push,
    replace,
};

export default module;
